import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import { baseInfoReducer } from "./baseInfoReducer"
import * as auth from "../app/modules/Auth/_redux/authRedux";
import { shiftReducer } from "./shiftReducer";
import { sportReducer } from "./sportReducer";
import { dormReducer } from "./dormReducer";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  baseInfo: baseInfoReducer,
  shift: shiftReducer,
  sport: sportReducer,
  dorm: dormReducer

});

export function* rootSaga() {
  yield all([auth.saga()]);
}
